module.exports = __webpack_public_path__ + "static/6313024b-cfbb-4d61-9e6f-9657b747bc4b-4777cdf6d34e3d35b3d55f3594d4c8d0.webp";